require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-names-vice-president-of-financial-wellness.json") })
        }
      }, "path---articles-financial-center-names-vice-president-of-financial-wellness");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-names-vice-president-of-financial-wellness!./.cache/json/articles-financial-center-names-vice-president-of-financial-wellness.json
// module id = 1654
// module chunks = 231608221292675